<!-- client/src/components/common/ResponsiveVideoEmbed.vue -->
<template>
  <div class="video-wrapper z-0">
    <iframe
      :src="computedSrc"
      frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      allowfullscreen
      title="YouTube video player"
    />
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  videoId: {
    type: String,
    required: true
  }
})

const computedSrc = computed(() =>
  `https://www.youtube-nocookie.com/embed/${props.videoId}?autoplay=1&rel=0&modestbranding=1&controls=1`
)
</script>

<style scoped>
.video-wrapper {
  position: relative;
  z-index: 10;
  width: 100%;
  height: 100%;
  flex: 1;
  overflow: hidden;
}

.video-wrapper iframe {
  width: 100%;
  height: 100%;
  border: 0;
  display: block;
  z-index: 10;
  top: 0;
  left: 0;
}



</style>
